<template>
    <div class="page">
        <div class="header">
            <span class="title">居延旅行社管理</span>
            <van-icon class="logout-btn" name="logout" @click="onLogout" />
        </div>
        <div class="menu-box">
            <div class="menu-btn menu-btn-group" @click="toGroupTourList">
                <van-icon name="friends-o" class="btn-icon" />
                <span class="btn-text">跟团游报价</span>
            </div>
            <div class="menu-btn menu-btn-private" @click="toPrivateTourList">
                <van-icon name="contact" class="btn-icon" />
                <span class="btn-text">私家团报价</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {Icon} from 'vant';

    export default {
        name: "index",
        components: {
            [Icon.name]: Icon
        },
        methods: {
            toGroupTourList() {
                this.$router.push({ name: 'groupTourList' })
            },
            toPrivateTourList() {
                this.$router.push({ name: 'privateTourList' })
            },
            onLogout() {
                this.$store.dispatch('user/resetToken').then(() => {
                    this.$router.replace({ name: 'login' })
                    this.$toast('已退出登录')
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .page {
        min-height: 100vh;
        background: #f5f7fa;
        padding-bottom: 20px;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 20px 30px;
        background: #0079DD;
        color: #fff;

        .title {
            font-size: 20px;
            font-weight: bold;
        }

        .logout-btn {
            font-size: 22px;
            color: #fff;
        }
    }

    .menu-box {
        padding: 0 16px;
        padding-top: 20px;
    }

    .menu-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100px;
        margin-bottom: 16px;
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        cursor: pointer;

        &:active {
            opacity: 0.85;
        }

        .btn-icon {
            font-size: 28px;
            color: #fff;
            margin-right: 12px;
        }

        .btn-text {
            font-size: 22px;
            font-weight: bold;
            color: #fff;
        }
    }

    .menu-btn-group {
        background: linear-gradient(135deg, #0079DD 0%, #004a99 100%);
    }

    .menu-btn-private {
        background: linear-gradient(135deg, #FF6B35 0%, #E85D26 100%);
    }
</style>
